import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[AlphaOnly]'
})
export class AlphaOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    //debugger;
    const initalValue = this._el.nativeElement.value;
   this._el.nativeElement.value = initalValue.replace(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/, '');
   //this._el.nativeElement.value = initalValue.replace(/^\d{0,9}(\.\d{1,9})?$/, '');
   if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }


    //this._el.nativeElement.value = initalValue.replace(/(.*)\.[0-9][0-9]/g, '');

    // Allow Only Alpha  /[^A-Za-z ]/  "/(.*)\.[0-9][0-9]/g"
     // Allow Only Number  "/[^0-9]*/g"
}